import { APPOINTMENT_REMINDER_URL } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default async function sendAppointmentReminder({
    aid,
}: {
    aid: string;
}): Promise<{
    success: boolean;
    error?: string;
}> {
    const response = await fetchWithRefresh(APPOINTMENT_REMINDER_URL(aid), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });

    const res = await response.json();
    return res;
}
